import { useEffect, useState } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export function useReleaseNotes(userProfile) {
  const [notes, setNotes] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!userProfile) return;
    getDocs(query(collection(db, 'releaseNotes'), orderBy('publishedAt', 'desc')))
      .then(snap => {
        setNotes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, [userProfile?.uid]); // eslint-disable-line react-hooks/exhaustive-deps

  const lastSeen = userProfile?.lastSeenReleaseAt?.toDate?.() ?? null;
  const unseenNotes = notes.filter(n => {
    const pub = n.publishedAt?.toDate?.();
    return pub && (!lastSeen || pub > lastSeen);
  });

  return { notes, unseenNotes, loaded };
}
